import React from 'react';
import { Zap, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button } from '../ui/Button';
export function HeroPricing() {
  return <section className="bg-forest-green py-8 md:py-10 px-4 relative overflow-hidden border-t border-green-accent/30" data-id="element-154">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(212,160,23,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-155"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-156">
        <p className="text-xl md:text-2xl text-gold-light mb-1 font-bold" data-id="element-157">
          Precio regular:{' '}
          <span className="line-through decoration-[3px] decoration-danger" data-id="element-158">
            42.000
          </span>
        </p>
        <div className="flex justify-center items-baseline gap-2 mb-2" data-id="element-159">
          <span className="text-[5rem] md:text-[8rem] font-black text-gold font-serif drop-shadow-[0_0_30px_rgba(212,160,23,0.5)] leading-none tracking-tighter" data-id="element-160">
            14.990
          </span>
          <span className="text-xl md:text-2xl text-gold-light/80 font-bold" data-id="element-161">
            ARS
          </span>
        </div>
        <p className="text-sm md:text-base text-green-400 font-bold mb-2" data-id="element-162">
          Ahorro de 27.000 ARS
        </p>
        <p className="text-lg md:text-xl font-black text-cream tracking-wide uppercase bg-white/10 inline-block px-6 py-2 rounded-full border border-white/20 mb-5" data-id="element-163">
          Pago único · Sin costos mensuales
        </p>
        <div className="mt-4" data-id="element-164">
          <Button fullWidth className="md:w-auto text-xl md:text-2xl py-5 md:py-6 shadow-[0_0_40px_rgba(212,160,23,0.6)]" data-id="element-165">
            QUIERO TRANSFORMAR A MI MASCOTA AHORA
          </Button>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm md:text-base text-cream font-bold mt-5 bg-black/20 py-4 px-6 rounded-xl border border-white/10" data-id="element-166">
          <div className="flex items-center gap-2" data-id="element-167">
            <ShieldCheck className="w-5 h-5 text-gold" data-id="element-168" />
            <span data-id="element-169">Compra única</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-170">
            <Lock className="w-5 h-5 text-gold" data-id="element-171" />
            <span data-id="element-172">Sin cuotas mensuales</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-173">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-174" />
            <span data-id="element-175">Acceso inmediato digital</span>
          </div>
        </div>
      </div>
    </section>;
}